const getEventValue = (key, event) => {
    const metaKey = 'day' === key ? 'date' : key

    if(event.meta_data.hasOwnProperty(metaKey)) {
        const providerKey = event.meta_data[metaKey].provider

        if('date' === key) {
            return event[providerKey].date.date
        } else if('day' === key) {
            return event[providerKey].date.day
        } else {
            return event[providerKey][key]
        }
    } else {
        return event[key]
    }
}

export default getEventValue